import React, { memo } from "react";
import AerosNode, { OptionList, OptionRow } from "./AerosNode";
import { nodeSummary } from "../flowRules";
import { i18n } from "../../../translate/i18n";

// Alças "true"/"false" são contrato do backend (sourceHandle === "true"|"false").
export default memo(({ data, isConnectable, id, selected }) => (
  <AerosNode
    id={id}
    type="conditionCompare"
    selected={selected}
    isConnectable={isConnectable}
    hasSource={false}
    error={typeof data?.error === "string" ? data.error : undefined}
    options={
      <OptionList>
        <OptionRow
          badge="✓"
          label={i18n.t("aeros.flow.condition.true")}
          tone="act"
          handleId="true"
          isConnectable={isConnectable}
          dotColor="#34D399"
        />
        <OptionRow
          badge="✕"
          label={i18n.t("aeros.flow.condition.false")}
          tone="red"
          handleId="false"
          isConnectable={isConnectable}
          dotColor="#F87171"
        />
      </OptionList>
    }
  >
    {nodeSummary({ type: "conditionCompare", data })}
  </AerosNode>
));
